// extracted by mini-css-extract-plugin
export var container = "_bh-1";
export var cornerButtonContainer = "_bh-5";
export var disabled = "_bh-2";
export var fileContainer = "_bh-4";
export var hiddenInput = "_bh-3";
export var widthContainer = "_bh-0";